import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BottomBar from "./BottomBar";
import SideBar from "./SideBar";
import TopBar from "./TopBar";

export default function DashboardLayout({ children }) {
  const navigate = useNavigate();
  useEffect(() => {
    if (
      !localStorage.getItem("swToken") ||
      localStorage.getItem("swToken") == ""
    ) {
      //toast.error("Not valid user to access that page , please login.");
      localStorage.clear();
      navigate("/Login");
    }
  }, []);

  return (
    <>
      <TopBar />
      <div className="flex flex-row min-h-screen font-nunito">
        <div className="hidden lg:flex lg:shrink-0 mt-20 basis-1/6 min-h-full flex-col">
          <SideBar />
        </div>
        <div className="mx-auto relative shrink-1 lg:basis-5/6 flex flex-col min-h-full">
          <div className="mt-28 -ml-4 lg:ml-4 flex-grow">{children}</div>
          <BottomBar />
        </div>
      </div>
    </>
  );
}
